import Siprec from './factory/Siprec'

export default Siprec({
  name: 'accesses'
})



// WEBPACK FOOTER //
// ./src/models/Access.js